module.exports = require('./dec/decode').BrotliDecompressBuffer;



//////////////////
// WEBPACK FOOTER
// ./~/brotli/decompress.js
// module id = UC9m
// module chunks = 0